module.exports = __webpack_public_path__ + "static/book-form-3aff7210b8d17e5c212868d9f187f984.jpg";